/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_TypingInputs */

const tr_mascot_chat_typing = /** @type {(inputs: Mascot_Chat_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinx yazıyor…`)
};

const en_mascot_chat_typing = /** @type {(inputs: Mascot_Chat_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinx is typing…`)
};

const de_mascot_chat_typing = /** @type {(inputs: Mascot_Chat_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinx schreibt…`)
};

const ru_mascot_chat_typing = /** @type {(inputs: Mascot_Chat_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinx пишет…`)
};

/**
* | output |
* | --- |
* | "Jinx is typing…" |
*
* @param {Mascot_Chat_TypingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_typing = /** @type {((inputs?: Mascot_Chat_TypingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_TypingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_typing(inputs)
	if (locale === "de") return de_mascot_chat_typing(inputs)
	if (locale === "ru") return ru_mascot_chat_typing(inputs)
	return tr_mascot_chat_typing(inputs)
});